module.exports = __webpack_public_path__ + "img/Faux Wood.85bec06a.jpg";